import { render, staticRenderFns } from "./ViewSalesInvoiceComponent.vue?vue&type=template&id=96122f16"
import script from "./ViewSalesInvoiceComponent.vue?vue&type=script&lang=js"
export * from "./ViewSalesInvoiceComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports